import { ValueOf } from '@/types/util';

export const terminalStatus = {
  WAITING: '有効待ち',
  AVAILABLE: '有効',
  CLOSED: '終了',
} as const;

export type TerminalStatusKey = keyof typeof terminalStatus;
export type TerminalStatusValue = ValueOf<typeof terminalStatus>;

export const terminalStatusKeys = Object.keys(terminalStatus) as TerminalStatusKey[];

/** v-select用items */
export const terminalStatusItems = terminalStatusKeys
  .map((key) => ({
    title: terminalStatus[key],
    value: key,
  }));
